import { OnOffOption } from '../../../../_types';
import { horizontalOptimizationCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

const labelMap: Record<OnOffOption, string> = {
  [OnOffOption.ON]: 'On',
  [OnOffOption.OFF]: 'Off',
};

const horizontalOptimizationOptions = Object.values(OnOffOption).map(
  (option) => ({
    title: labelMap[option],
    value: option,
  })
);

export const HorizontalOptimizationQuickSearch = () => {
  return (
    <QuickSearchFilter
      options={horizontalOptimizationOptions}
      criterion={horizontalOptimizationCriterion}
      multiple
    />
  );
};
